import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

export function loginApi(username, password) {
    return axios.post(`${API_BASE}/auth/token/`, { username, password });
}

export function refreshTokenApi(refresh) {
    return axios.post(`${API_BASE}/auth/token/refresh/`, { refresh });
}

export function logoutApi(accessToken) {
    if (!accessToken) return Promise.resolve();
    return axios.post(`${API_BASE}/auth/logout/`, {}, {
        headers: { Authorization: `Bearer ${accessToken}` },
    }).catch(() => {}); // fire-and-forget; do not block logout on network failure
}

function parseJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(window.atob(base64));
}

export function saveTokenInLocalStorage(tokenDetails) {
    const payload = parseJwt(tokenDetails.access);
    tokenDetails.expireDate = new Date(payload.exp * 1000).toISOString();
    localStorage.setItem('userDetails', JSON.stringify(tokenDetails));
}

export function loadTokenFromLocalStorage() {
    const raw = localStorage.getItem('userDetails');
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch {
        return null;
    }
}

export function isLogin() {
    const details = loadTokenFromLocalStorage();
    if (!details) return false;
    return new Date() < new Date(details.expireDate);
}
